import styled from 'styled-components'
import { MOBILE_WIDTH } from 'utils/constants'

export const DocumentsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
  padding: 2rem;

  h2 {
    font-size: 1.125rem;
    font-weight: 400;
    color: #4a5568;
    margin: 1rem 0;

    strong {
      font-weight: 600;
      color: #00607f;
    }
  }

  @media ${MOBILE_WIDTH} {
    padding: 1rem;
  }
`

export const DocumentsContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  width: 100%;
`

export const FileInputsWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
  width: 100%;

  @media ${MOBILE_WIDTH} {
    grid-template-columns: 1fr;
  }
`
